import { useTranslation } from 'react-i18next';
import Card from '~/components/layout/Card';
import { HStack, VStack } from '~/components/layout/Stack';
import Text from '~/components/typographies/Text';
import IconArrowTrendDown from '~/icons/icon-arrow-trend-down.svg?react';
import IconArrowTrendUp from '~/icons/icon-arrow-trend-up.svg?react';
import { Reconciliation } from '~/types/reconciliation';
import { counterpartName } from '~/utils/counterparts';
import { formatMoney } from '~/utils/money';
import styles from './BookkeepingReconciliationDetailCard.module.scss';

const BookkeepingReconciliationDetailCard = ({ reconciliation }: { reconciliation: Reconciliation }) => {
  const { t: documentsT } = useTranslation('documents');

  const document = reconciliation.flow?.document;
  if (!document) {
    return null;
  }

  return (
    <Card padding={2} shadow="none" radius="small">
      <HStack align="center" justify="space-between">
        <VStack gap={1}>
          <Text variant="body2" weight="semibold">
            {counterpartName(document.counterpart, '--')}
          </Text>
          <Text variant="caption" weight="medium">
            {documentsT(`type.${document.documentType}`)} {document.number && <>• {document.number}</>}
          </Text>
        </VStack>
        <HStack gap={1} align="center">
          <Text variant="body2" weight="semibold">
            {formatMoney(reconciliation.flow!.amount)}
          </Text>
          {document.isInflow ? (
            <IconArrowTrendUp className={styles.inflow} />
          ) : (
            <IconArrowTrendDown className={styles.outflow} />
          )}
        </HStack>
      </HStack>
    </Card>
  );
};

export default BookkeepingReconciliationDetailCard;
